import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';

const LoadingPlaceholderWrapper = styled('div')(
  ({ theme }) => ({
    marginBottom: 8,
    width: '100%',
    height: 80,
    backgroundColor: theme.palette.action.selected,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '.MuiCircularProgress-root': {
      color: theme.palette.action.disabled,
    },
  }),
  addBorderInHighContrastMode,
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: theme.isDark ? grey[900] : undefined,
    boxSizing: 'border-box',
    '.MuiCircularProgress-root': {
      color: theme.palette.text.primary,
    },
  })),
);

const ThumbnailLoadingPlaceholder = () => (
  <LoadingPlaceholderWrapper>
    <CircularProgress size={18} />
  </LoadingPlaceholderWrapper>
);

export default ThumbnailLoadingPlaceholder;
